import Table from '@/components/common/Table'
import useCrashDetectionTableHook from './CrashDetectionTable.hook'
import {
  BoxSearch,
  CardContainer,
  HeaderWrapper,
  SearchIcon,
  SearchInput,
  TableContainer,
} from './styles'
import { Switch } from 'antd'

const CrashDetectionTable = () => {
  const {
    data,
    isLoading,
    columns,
    inputValue,
    onSearch,
    onTableChange,
    isAutoUpdate,
    setIsAutoUpdate,
    setSelectedRowId,
    selectedRowId,
  } = useCrashDetectionTableHook()

  return (
    <CardContainer>
      <HeaderWrapper>
        <BoxSearch>
          <SearchInput
            placeholder="ค้นหาชื่อ-นามสกุล, เลขกรมธรรม์, เบอร์โทรศัพท์, ทะเบียนรถ"
            prefix={<SearchIcon />}
            value={inputValue}
            onChange={onSearch}
          />
        </BoxSearch>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '14px', fontWeight: 500, color: '#262626' }}>
            อัปเดตข้อมูลอัตโนมัติทุก 15 วินาที
          </span>
          <Switch
            checked={isAutoUpdate}
            onChange={setIsAutoUpdate}
            style={{
              backgroundColor: isAutoUpdate ? '#009640' : '#d9d9d9',
            }}
          />
        </div>
      </HeaderWrapper>
      <TableContainer>
        <Table
          rowKey="id"
          columns={columns}
          dataSource={data?.data || []}
          loading={isLoading}
          scroll={{ x: 2720 }}
          sticky={true}
          pagination={{
            pageSizeOptions: [10, 25, 50, 100],
            showSizeChanger: true,
            total: data?.meta.totalItems,
            current: data?.meta.currentPage,
            pageSize: data?.meta.itemsPerPage,
          }}
          onChange={onTableChange}
          onRow={(record) => ({
            onClick: () => setSelectedRowId(record.id === selectedRowId ? null : record.id),
          })}
          rowClassName={(record) => (record.id === selectedRowId ? 'selected-row' : '')}
        />
      </TableContainer>
    </CardContainer>
  )
}

export default CrashDetectionTable
